module.exports = __webpack_public_path__ + "img/sidebar-standards-ico-blue-01.8b145460.svg";